
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import MobileHeader from "../../components/header/MobileHeader";
import LoginHeader from "../../components/header/LoginHeader";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import Breadcrumb from "../../components/breadcrumb";
import OfferedSide from "./OfferedSide";
import OfferedSec from "./OfferedSec";
import dataCandi from "../../assets/fakeData/dataCandi";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";

OfferedJobs.propTypes = {};

function OfferedJobs(props) {

    const [isShowMobile, setShowMobile] = useState(false);



    const handleMobile = () => {
        const getMobile = document.querySelector(".menu-mobile-popup");
        setShowMobile(!isShowMobile);
        !isShowMobile
            ? getMobile.classList.add("modal-menu--open")
            : getMobile.classList.remove("modal-menu--open");
    };

    useEffect(() => {
        const WOW = require("wowjs");
        window.wow = new WOW.WOW({
            live: false,
        });
        window.wow.init();
    }, []);

    return (
        <>
            <LoginMobileHeader handleMobile={handleMobile} />
            <LoginHeader clname="act1" handleMobile={handleMobile} />
            {/* <Breadcrumb title="Offered Jobs" className="breadcrumb-section" /> */}

            <OfferedSide />
            <OfferedSec data={dataCandi} />

            {/* <Footer /> */}
            <Gotop />
        </>
    );
}

export default OfferedJobs;
